import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../../security/services/authentication.service';
import { environment } from '../../../../environments/environment';
import { FormIdentifier } from '../../../project/models/form-identifier.model';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import {
  HttpClient,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';

@Injectable()
export class SignaturesSendService {
  private readonly postSendAgreement = `${environment.apiUrl}/agreement/send`;
  private readonly postCheckIrrevocableDesigneeSent = `${environment.apiUrl}/agreement/IrrevocableDesigneeSent`;
  private readonly postCheckIrrevocableDesigneeExecuted = `${environment.apiUrl}/agreement/IrrevocableDesigneeExecuted`;
  constructor(
    private authService: AuthenticationService,
    private http: HttpClient,
    private swal: SwalService
  ) {}

  sendAgreement(formId: FormIdentifier, templateSuffix = null) {
    const that = this;
    return new Observable<string>(subscriber => {
      that.swal.load('Sending Form for Signature...', 'Please wait.');
      that.http
        .post(that.postSendAgreement + `?templateSuffix=${templateSuffix}`, formId, that.authService.getAuthOptions())
        .pipe(
          map((response: string) => {
            let agreementId: string = null;
            if (response) {
              agreementId = response;
            }

            return agreementId;
          })
        )
        .pipe(catchError(this.handleError))
        .subscribe(
          agreementId => {
            that.swal
              .success({
                title: 'Success!',
                text: 'Form has been sent for signature!'
              })
              .then(() => {
                subscriber.next(agreementId);
                subscriber.complete();
              })
              .catch(() => {
                subscriber.next(agreementId);
                subscriber.complete();
              });
          },
          error =>
            that.swal
              .error({
                title: 'Oops!',
                text: 'An error occurred while sending form for signature.'
              })
              .then(() => {
                subscriber.complete();
              })
              .catch(() => {
                subscriber.complete();
              })
        );
    });
  }
  private handleError(error: HttpErrorResponse | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpErrorResponse) {
      errMsg = `${error.status} - ${error.statusText || ''} ${error.message}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.log('Fantastic, it does not work!!');
    console.error(errMsg);
    return throwError(errMsg);
  }
  irrevocableDesigneeLetterExecuted(formId: FormIdentifier) {
    const that = this;
    return new Observable<boolean>(subscriber => {
      that.http
        .post(that.postCheckIrrevocableDesigneeExecuted, formId, that.authService.getAuthOptions())
        .pipe(
          map((response: boolean) => {
            return response;
          })
        )
        .pipe(catchError(this.handleError))
        .subscribe(
          response => {
            subscriber.next(response);
            subscriber.complete();
          },
          error =>
            that.swal
              .error({
                title: 'Oops!',
                text: 'An error occurred checking for Irrevocable Designee Signature Status.'
              })
              .then(() => {
                subscriber.complete();
              })
              .catch(() => {
                subscriber.complete();
              })
        );
    });
  }

  irrevocableDesigneeLetterSent(formId: FormIdentifier) {
    const that = this;
    return new Observable<boolean>(subscriber => {
      that.http
        .post(that.postCheckIrrevocableDesigneeSent, formId, that.authService.getAuthOptions())
        .pipe(
          map((response: boolean) => {
            return response;
          })
        )
        .pipe(catchError(this.handleError))
        .subscribe(
          response => {
            subscriber.next(response);
            subscriber.complete();
          },
          error =>
            that.swal
              .error({
                title: 'Oops!',
                text: 'An error occurred checking for Irrevocable Designee Signature Status.'
              })
              .then(() => {
                subscriber.complete();
              })
              .catch(() => {
                subscriber.complete();
              })
        );
    });
  }
}
